import { P0, S, abs, arc, fillAt, max, rotPts } from '../../geometry';

export const cactus = {
  name: 'Cactus',
  colors: ['#2F9E5B', '#D6409F'],
  draw(m, t) {
    let aL = 4 * S(t * 1.5),
      aR = 4 * S(t * 1.5 + 1.4),
      fl = 1 + 0.08 * S(t * 2),
      pose = P0();
    if (m === 'happy') {
      aL = -30 + 25 * S(t * 9);
      aR = 30 - 25 * S(t * 9 + 1);
      pose.ty = -2 * abs(S(t * 6));
      fl = 1.25;
    }
    // Thinking: the arms keep lifting and lowering in turn.
    if (m === 'thinking') {
      aL = 24 * S(t * 2.6);
      aR = 24 * S(t * 2.6 + Math.PI);
    }
    if (m === 'talking') {
      fl = 1 + 0.3 * max(0, S(t * 10));
      aL = 6 * S(t * 10);
      aR = -aL;
    }
    if (m === 'surprised') {
      aL = -35;
      aR = 35;
      fl = 1.35;
    }
    if (m === 'paused') {
      aL = 120;
      aR = -120;
      fl = 0.7;
      pose.sy = 0.94;
    }
    const body = [
      [37, 84],
      [37, 62],
      ...arc(50, 40, 13, 180, 360, 9),
      [63, 62],
      [63, 84],
    ];
    const armL = rotPts(
        [
          [37, 64],
          [29, 64],
          [26, 58],
          [26, 48],
        ],
        37,
        64,
        aL
      ),
      armR = rotPts(
        [
          [63, 58],
          [71, 58],
          [74, 52],
          [74, 42],
        ],
        63,
        58,
        aR
      );
    const bloom = arc(50, 22.5, 3.6 * fl, -90, 270, 9);
    return {
      strokes: [
        { c: 'a', pts: body, n: 24 },
        { c: 'a', pts: armL },
        { c: 'a', pts: armR },
        { c: 'b', pts: bloom },
        {
          c: 'a',
          pts: [
            [26, 86],
            [74, 86],
          ],
        },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
